<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark>Anular Factura Electronica.</v-toolbar>
        <v-card-text>
          <v-container class="mt-1">
            <v-select
              label="* Codigo Motivo"
              v-model="anular.codigoMotivo"
              :items="motivos"
              item-value="codigo"
              :loading="loadingmot"
              dense
              outlined
            ></v-select>
          </v-container>

          <v-progress-linear indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="save2()" class="green darken-2" dark :disabled="loading">
            anular
          </v-btn>
          <v-btn text @click="dialog.value = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  import axios from 'axios';
  import { getAccessToken } from '@/accessToken';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        loadingmot: false,
        msg: '',
        motivos: [],
        anular: {
          codigoMotivo: 1,
          descripcionMotivo: '',
          cuf: '',
          id: null,
        },
        apikeytoken: '',
      };
    },
    components: {},
    watch: {
      'anular.codigoMotivo': function() {
        let m = this.motivos.find((x) => x.codigo == this.anular.codigoMotivo);
        if (m) this.anular.descripcionMotivo = m.descripcion;
      },
    },
    methods: {
      async openmodal(item, apikey=null) {
        // window.console.log('--------', item);
        this.msg = '';
        this.dialog = true;
        this.loading = false;
        await this.obtenerToknFactura(item.nit);
        this.getmotivosanulacion(apikey);
        this.anular.codigoMotivo = null;
        this.anular.descripcionMotivo = null;
        this.anular.cuf = item.cuf;
        this.anular.id = item.id;
      },
      getmotivosanulacion(apikey) {
        this.loadingmot = true;
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/catalogo/motivoanulacion`,
          headers: {
            // apikey: this.$store.getters.getApiKey,
            apikey: apikey?apikey:this.apikeytoken,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            data.map((x) => {
              x.codigo = parseInt(x.codigo);
              x.text = `${x.descripcion} (${x.codigo})`;
            });
            vue.motivos = data;
            vue.loadingmot = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingmot = false;
          });
      },
      save() {
        this.msg = '';
        if (!this.anular.codigoMotivo) this.msg = 'Seleccione un motivo.';
        if (!this.anular.descripcionMotivo) this.msg = 'no hay descripcion de motivo';
        if (!this.anular.cuf) this.msg = 'no hay cuf';
        if (this.msg) return;

        this.loading = true;
        let metodo = 'post';
        const vue = this;
        var config = {
          method: metodo,
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/anular`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.apikeytoken,
          },
          data: this.anular,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.respuestaServicioFacturacion;
            window.console.log('pventanew::', data);
            if (data.codigoDescripcion) {
              vue.msg = data.codigoDescripcion;
              vue.$emit('anuladofact', data);
            }
            vue.loading = false;
            setTimeout(() => {
              vue.dialog = false;
            }, 800);
          })
          .catch(function(error) {
            vue.msg = 'Termino lo que tuvo que terminarse'
            vue.loading = false;
            window.console.log(error.response);
            let data = error.response.data.respuestaServicioFacturacion.mensajesList[0];
            vue.msg = `${data.codigo} ${data.descripcion}`;
            vue.loading = false;
          });
      },
      async obtenerToknFactura(nro_nit) {
        // let idsuc = this.$route.query.idsucursal;
        let tok = getAccessToken();
        const apiAxios = axios.create({
          baseURL: '',
          headers: {
            'Content-Type': 'application/json',
            Authorization: tok,
          },
        });
        let nits = await apiAxios.get(`${process.env.VUE_APP_API_REST}/api/v1/esam/nits`).then(({ data }) => data.data);

        this.apikeytoken = nits.find((n) => n.nro == nro_nit).apikey;

        /* window.console.log('TOKENNNNNNNNNNN::--------------------------');
        window.console.log('>>>> ', this.$store.getters.getApiKey);
        window.console.log('>>>> ', this.apikeytoken); */
      },
      save2() {
        //let idfactura = this.anular.id;
        this.msg = '';
        if (!this.anular.codigoMotivo) this.msg = 'Seleccione un motivo.';
        if (!this.anular.descripcionMotivo) this.msg = 'no hay descripcion de motivo';
        if (!this.anular.cuf) this.msg = 'no hay cuf';

        let userid = this.$store.state.DATA_USER.id;
        if(userid == 43){
          this.msg = 'Usuario no autorizado';
        } 

        if (this.msg) return;

        this.loading = true;
        let metodo = 'post';
        const vue = this;
        var config = {
          method: metodo,
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/anular/id`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.apikeytoken,
          },
          data: this.anular,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.respuestaServicioFacturacion;
            window.console.log('pventanew::', response.data);
            if (data.codigoDescripcion) {
              vue.msg = data.codigoDescripcion;
              vue.$emit('anuladofact', data);
            }
            vue.loading = false;
            setTimeout(() => {
              vue.dialog = false;
            }, 800);
          })
          .catch(function(error) {
            window.console.log(error.response);
            let data = error.response.data.respuestaServicioFacturacion.mensajesList[0];
            vue.msg = `${data.codigo} ${data.descripcion}`;
            vue.loading = false;
          });
      },
    },
  };
</script>
